const port = 8000;
export const url = process.env.REACT_APP_BACKEND_URL
export const chatUrl = ''
